import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/holiday_page.jpg'
import _imports_1 from '../../assets/holiday_select.png'
import _imports_2 from '../../assets/holiday_unselect.png'


const _hoisted_1 = { class: "our_holiday" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "banner_img_cba" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"margin":"0px 0px 0px 0px"},
    alt: ""
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "holiday_name" }, "网络中国节系列 ", -1)
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  style: {"width":"60px","height":"30px"},
  class: "image-container"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_2,
  style: {"width":"60px","height":"30px"},
  class: "image-container"
}
const _hoisted_6 = { class: "overlay-text" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "holiday_list" }
const _hoisted_9 = { style: {"flex-direction":"column","padding-left":"0.5vh"} }
const _hoisted_10 = { class: "child_title" }
const _hoisted_11 = { style: {"display":"flex"} }
const _hoisted_12 = { class: "recordTime" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_van_tabs, {
      active: _ctx.activeIndex,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeIndex) = $event)),
      scrollspy: "",
      sticky: "",
      onClickTab: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickTab(_ctx.activeIndex))),
      background: "antiquewhite",
      color: "antiquewhite"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ourHolidayTabList, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_tab, { key: index }, {
            title: _withCtx(() => [
              (_ctx.activeIndex==index)
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5)),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createVNode(_component_van_list, {
          class: "van-list-container2",
          loading: _ctx.loading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
          offset: "10",
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.holidayList, (child, index) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_ctx.gotoDetail(child.href))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_van_image, {
                    src: child.thumbnailsJson[0],
                    alt: "",
                    width: "100",
                    height: "60"
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(child.title), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(child.recordTime), 1)
                    ])
                  ])
                ])
              ], 8, _hoisted_7))
            }), 256))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ])
    ])
  ]))
}